import React, { Fragment, useContext, useEffect, useState } from 'react'
import { Box, Card, CardActionArea, CardContent, CardMedia, Chip, Grid, Typography, useTheme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { CallToAction } from '../CalltoAction'
import { TitleSection } from '../Typography'
import { NavLink } from 'react-router-dom'
import ListProductsEskeleton from './ListProductsEskeleton'
import { Pagination, PaginationItem } from '@material-ui/lab'
import { WhatshotRounded } from '@material-ui/icons'
import GA4 from '../../services/GA4/ga4'
import { isWebpSupported } from 'react-image-webp/dist/utils'
import noProductImage from '../../assets/img/noImage.png'
import handleOnImageError from '../../utils/handleOnImageError'
import ShopContext from '../../contexts/Shop'

//
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginBottom: theme.spacing(3),
  },
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(206px, 1fr))',
  },
  cardContainer: {
    margin: theme.spacing(1),
  },
  card: {
    padding: 14,
    transition: 'transform .2s',
    '&:hover': {
      transform: 'scale(1.1)',
    },
    minHeight: 362,
  },
  media: {
    height: 0,
    paddingBottom: 100 + '%',
    borderWidth: 1,
    borderColor: theme.palette.primary.main,
  },
  content: {
    textAlign: 'center',
  },
  cardAction: {
    '&:hover': {
      textDecoration: 'none',
      color: theme.palette.text.dark,
    },
  },
  title: {
    lineHeight: 1,
    color: theme.palette.text.primary,
    height: 49,
    [theme.breakpoints.down('sm')]: {
      height: 51,
      fontSize: '0.8rem',
    },
  },
  subtitle: {
    color: theme.palette.text.secondary,
  },
  qty: {
    color: theme.palette.primary.main,
  },
  price: {
    color: theme.palette.text.primary,
    fontSize: '1.3rem',
  },
  unit: {
    lineHeight: 0.5,
    textTransform: 'none',
    color: theme.palette.text.primary[300],
    fontSize: '12px',
    marginTop: 4,
  },
  CallToActionContainer: {
    textAlign: 'center',
    padding: '35px 0',
  },
  PaginationContainer: {
    marginTop: theme.spacing(7),
    marginBottom: theme.spacing(3),
  },
  PaginationItem: {
    fontSize: '1.3rem',
    color: theme.palette.text.secondary,
    '&:hover': {
      color: theme.palette.secondary.main,
      backgroundColor: theme.palette.primary.dark,
      textDecoration: 'none',
    },
  },
  vitrineValues: {
    display: 'flex',
    justifyContent: 'center',
    gap: '3px',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  vitrinePricesArea: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
}))

const VitrineProdutos = ({
  title,
  titleStyle,
  backgroundCardsContainer,
  paddingCardsContainer,
  xs,
  sm,
  numItens,
  button,
  pagination,
  emptyMessage,
  ...props
}) => {
  const _products = props.dataProducts
  const shop = useContext(ShopContext);
  const classes = useStyles(props)
  const theme = useTheme()

  const [products, setProducts] = useState([])
  const [lastPage, setLastPage] = useState(null)
  const [total, setTotal] = useState(null)
  const [skeleton, setSkeleton] = useState(true)
  const [_page, setPage] = useState(props.page || 1)

  useEffect(() => {
    function loadProducts(prods) {
      /* prods.products.forEach((item) => {
        item.preco_card_vitrine.forEach((value) => {
          value['label'] = (
            <span>
              Uni p/ <b style={{ color: theme.palette.primary.main, fontSize: '14px' }}>{value.quantidade}</b> peças
            </span>
          )
        })
      }) */
      setProducts(prods.products)
      if (pagination) {
        setTimeout(function () {
          window.scroll({ top: 0, left: 0, behavior: 'smooth' })
        }, 2)
        setLastPage(prods.lastPage)
        setTotal(prods.total)
        setPage(prods.page)
      }
    }

    _products.subscribe(loadProducts)

    return function cleanup() {
      _products.unsubscribe(loadProducts)
    }
  }, [_products])

  useEffect(() => {
    async function callProducts(objProd) {
      await objProd.all(
        shop.id,
        props.search || '',
        numItens || 5,
        props.offSet || 0,
        props.page,
        props.category || null,
        props.subcategory || null,
        props.except || null,
        props.offers || null
      )
      setSkeleton(false)
    }

    setSkeleton(true)
    callProducts(_products)
  }, [props.search, props.offSet, props.page, numItens, props.category, props.subcategory, props.except])

  useEffect(() => {
    GA4.viewListProduct(products, props.name || title || 'Vitrine de Produtos')
  }, [products])

  function handleClickCard(product, index) {
    GA4.selectItem(product, props.name || title || 'Vitrine de Produtos', index)
  }

  if (total === 0)
    return (
      <Grid container alignItems="center" justify="center" alignContent="center" style={{ minHeight: 300 }}>
        <Typography variant="h4" component="h3">
          {emptyMessage || `Nenhum resultado encontrado para "${props.search}".`}
        </Typography>
        {!emptyMessage && (
          <ul>
            <li>Verifique os termos digitados ou os filtros selecionados</li>
            <li>Utilize termos menos específicos para a busca</li>
          </ul>
        )}
      </Grid>
    )

  return (
    <Fragment>
      {title && <TitleSection text={title} style={titleStyle} />}
      <div
        className={classes.root}
        style={{
          backgroundColor: backgroundCardsContainer || 'transparent',
          padding: paddingCardsContainer || 0,
        }}
      >
        <Box className={classes.container}>
          {!skeleton &&
            products.map((product, index) => {
              if (!product.canonical_url) return

              return (
                <Box className={classes.cardContainer}>
                  <Card className={classes.card} onClick={() => handleClickCard(product, index)}>
                    <NavLink className={classes.cardAction} to={`${new URL(product.canonical_url).pathname}`}>
                      <CardActionArea component="div" disableRipple>
                        <CardMedia
                          style={{ height: 'auto', paddingBottom: '0' }}
                          className={classes.media}
                          title={product.nome}
                          /* src={
                            isWebpSupported() && product.media?.[0]?.full_webp_url
                              ? product.media?.[0]?.full_webp_url
                              : product.media?.[0]?.full_url
                          } */
                          src={product.image}
                          component="img"
                          onError={(e) => handleOnImageError(e, noProductImage)}
                        />
                        <CardContent className={classes.content}>
                          <Typography variant="subtitle1" className={classes.title}>
                            {product.nome}
                          </Typography>
                          <Typography variant="subtitle2" className={classes.subtitle}>
                            {product.codigo}
                          </Typography>
                          {product.oferta.length > 0 && (
                            <Chip
                              icon={<WhatshotRounded />}
                              label="Oferta!!"
                              color="secondary"
                              style={{
                                position: 'absolute',
                                top: -4,
                                right: -8,
                              }}
                            />
                          )}
                          <div className={classes.vitrinePricesArea}>
                            <Typography variant="button" component="p" className={classes.unit}>
                              A partir de
                            </Typography>
                            <div className={classes.vitrineValues}>
                              <Typography variant="button" className={classes.price}>
                                {parseFloat(product.valor).toLocaleString('pt-BR', {
                                  minimumFractionDigits: 2,
                                  style: 'currency',
                                  currency: 'BRL',
                                })}
                              </Typography>
                            </div>
                            {/* {product.preco_card_vitrine.map((item) => (
                              <div className={classes.vitrineValues}>
                                <Typography variant="button" className={classes.price}>
                                  {parseFloat(item.valor).toLocaleString('pt-BR', {
                                    minimumFractionDigits: 2,
                                    style: 'currency',
                                    currency: 'BRL',
                                  })}
                                </Typography>
                                <Typography variant="button" component="p" className={classes.unit}>
                                  {item.label}
                                </Typography>
                              </div>
                            ))} */}
                          </div>
                        </CardContent>
                      </CardActionArea>
                    </NavLink>
                  </Card>
                </Box>
              )
            })}
        </Box>
        {skeleton && (
          <ListProductsEskeleton
            numItens={numItens}
            xs={xs || 12}
            sm={sm || true}
            backgroundCardsContainer={backgroundCardsContainer}
            paddingCardsContainer={paddingCardsContainer}
          />
        )}
        {button && (
          <Grid
            container
            alignItems="center"
            alignContent="center"
            justify="center"
            className={classes.CallToActionContainer}
          >
            <CallToAction href="/busca/" />
          </Grid>
        )}

        {pagination && (
          <Grid
            xs={12}
            container
            alignItems="center"
            alignContent="center"
            justify="center"
            className={classes.PaginationContainer}
          >
            <Pagination
              color="primary"
              shape="rounded"
              count={lastPage}
              page={_page}
              showFirstButton
              showLastButton
              size="large"
              boundaryCount={2}
              renderItem={(item) => (
                <PaginationItem
                  component={NavLink}
                  to={`?page=${item.page}`}
                  className={classes.PaginationItem}
                  {...item}
                  //onClick={() => window.scrollTo({top: 0, left: 0, behavior: 'smooth' })}
                />
              )}
            />
          </Grid>
        )}
      </div>
    </Fragment>
  )
}

export default VitrineProdutos
